export default "__VITE_ASSET__99361dba__"